import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaArrowLeft } from 'react-icons/fa';
import './MessageControlModal.css';

const MessageControlModal = ({ show, onHide }) => {
  const [isEnabled, setIsEnabled] = useState(false);

  const handleToggle = () => {
    setIsEnabled(!isEnabled);
    // TODO: Add API call here when API is ready
    // await updateMessageControl(!isEnabled);
  };

  const handleBack = () => {
    onHide();
  };

  return (
    <Modal show={show} onHide={handleBack} centered className="message-control-modal">
      <Modal.Body className="message-control-modal-body">

        <div className="message-control-content pt-4">
          {/* Header */}
          <div className="message-control-header">
            <button className="back-button" onClick={handleBack}>
              <FaArrowLeft />
            </button>
            <h4 className="message-control-title">Message Control</h4>
            <div className="toggle-switch-wrapper">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={isEnabled}
                  onChange={handleToggle}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          {/* Description */}
          <p className="message-control-description">
            Standard users can configure their account to receive messages only from users they message first, giving them full control over incoming communication.
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MessageControlModal;

